interface AxisTickProps {
  x?: number;
  y?: number;
  payload?: {
    value: unknown;
  };
}

const CustomYAxisBytesTick = ({ x, y, payload }: AxisTickProps) => (
  <g transform={`translate(${x},${y})`}>
    <text textAnchor="end" dy={5} fill="#66768D">
      {String(payload?.value)} GB
    </text>
  </g>
);

export default CustomYAxisBytesTick;